import * as React from 'react'

import OptionsBody from '~/client/src/shared/components/OptionsList/pieces/OptionsBody'
import OptionsSearch from '~/client/src/shared/components/OptionsList/pieces/OptionsSearch'
import OptionsToolbar from '~/client/src/shared/components/OptionsList/pieces/OptionsToolbar'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import CategoryList from './CategoryList'
import { useDrillDownFilterContext } from './context'
import type { DrillDownFilterHeaderContent } from './DrillDownFilter.types'
import FlatItemList from './variants/FlatItemList'
import TreeItemList from './variants/TreeItemList'

export interface IDrillDownFilterBodyProps {
  resetSize?: 'sm' | 'default' | 'lg'
  autoFocusSearch?: boolean
  headerContent?: DrillDownFilterHeaderContent
}

export default function DrillDownFilterBody({
  resetSize,
  autoFocusSearch = true,
  headerContent,
}: IDrillDownFilterBodyProps) {
  const { state, actions, meta } = useDrillDownFilterContext()

  if (!meta.selectedCategory) {
    return (
      <CategoryList
        headerContent={headerContent}
        autoFocusSearch={autoFocusSearch}
      />
    )
  }

  return (
    <OptionsBody>
      <OptionsToolbar>
        <OptionsSearch
          value={state.searchTerm}
          onChange={actions.setSearchTerm}
          placeholder={Localization.translator.search}
          autoFocus={autoFocusSearch}
        />
      </OptionsToolbar>
      {meta.selectedCategory.kind === 'tree' ? (
        <TreeItemList resetSize={resetSize} />
      ) : (
        <FlatItemList resetSize={resetSize} />
      )}
    </OptionsBody>
  )
}
